(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './ktor-ktor-http.js', './ktor-ktor-utils.js', './kotlinx-serialization-kotlinx-serialization-json.js', './Kotlin-Immutable-Collections-kotlinx-collections-immutable.js', './kotlinx-io-kotlinx-io-core.js', './ktor-ktor-client-core.js', './Kermit-kermit-core.js', './Kermit-kermit.js', './ktor-ktor-client-content-negotiation.js', './ktor-ktor-serialization-kotlinx-json.js', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlinx-coroutines-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-utils.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./Kotlin-Immutable-Collections-kotlinx-collections-immutable.js'), require('./kotlinx-io-kotlinx-io-core.js'), require('./ktor-ktor-client-core.js'), require('./Kermit-kermit-core.js'), require('./Kermit-kermit.js'), require('./ktor-ktor-client-content-negotiation.js'), require('./ktor-ktor-serialization-kotlinx-json.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlinx-coroutines-core.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    if (typeof globalThis['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    if (typeof globalThis['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    if (typeof globalThis['Kotlin-Immutable-Collections-kotlinx-collections-immutable'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'Kotlin-Immutable-Collections-kotlinx-collections-immutable' was not found. Please, check whether 'Kotlin-Immutable-Collections-kotlinx-collections-immutable' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    if (typeof globalThis['kotlinx-io-kotlinx-io-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'kotlinx-io-kotlinx-io-core' was not found. Please, check whether 'kotlinx-io-kotlinx-io-core' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    if (typeof globalThis['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    if (typeof globalThis['Kermit-kermit-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'Kermit-kermit-core' was not found. Please, check whether 'Kermit-kermit-core' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    if (typeof globalThis['Kermit-kermit'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'Kermit-kermit' was not found. Please, check whether 'Kermit-kermit' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    if (typeof globalThis['ktor-ktor-client-content-negotiation'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'ktor-ktor-client-content-negotiation' was not found. Please, check whether 'ktor-ktor-client-content-negotiation' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    if (typeof globalThis['ktor-ktor-serialization-kotlinx-json'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'ktor-ktor-serialization-kotlinx-json' was not found. Please, check whether 'ktor-ktor-serialization-kotlinx-json' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-supabase-kt'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'supabase-kt-supabase-kt'.");
    }
    globalThis['supabase-kt-supabase-kt'] = factory(typeof globalThis['supabase-kt-supabase-kt'] === 'undefined' ? {} : globalThis['supabase-kt-supabase-kt'], globalThis['kotlin-kotlin-stdlib'], globalThis['ktor-ktor-http'], globalThis['ktor-ktor-utils'], globalThis['kotlinx-serialization-kotlinx-serialization-json'], globalThis['Kotlin-Immutable-Collections-kotlinx-collections-immutable'], globalThis['kotlinx-io-kotlinx-io-core'], globalThis['ktor-ktor-client-core'], globalThis['Kermit-kermit-core'], globalThis['Kermit-kermit'], globalThis['ktor-ktor-client-content-negotiation'], globalThis['ktor-ktor-serialization-kotlinx-json'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['kotlinx-coroutines-core']);
  }
}(function (_, kotlin_kotlin, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_utils, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_collections_immutable, kotlin_org_jetbrains_kotlinx_kotlinx_io_core, kotlin_io_ktor_ktor_client_core, kotlin_co_touchlab_kermit_core, kotlin_co_touchlab_kermit, kotlin_io_ktor_ktor_client_content_negotiation, kotlin_io_ktor_ktor_serialization_kotlinx_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var Exception = kotlin_kotlin.$_$.gn;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var lazy = kotlin_kotlin.$_$.to;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var listOf = kotlin_kotlin.$_$.ta;
  var isBlank = kotlin_kotlin.$_$.dk;
  var take = kotlin_kotlin.$_$.rl;
  var VOID = kotlin_kotlin.$_$.d;
  var URLBuilder = kotlin_io_ktor_ktor_http.$_$.b1;
  var toMap = kotlin_io_ktor_ktor_utils.$_$.f1;
  var mapCapacity = kotlin_kotlin.$_$.ua;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.i4;
  var firstOrNull = kotlin_kotlin.$_$.k9;
  var drop = kotlin_kotlin.$_$.rj;
  var listOf_0 = kotlin_kotlin.$_$.sa;
  var toString = kotlin_kotlin.$_$.hh;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var toList = kotlin_kotlin.$_$.jc;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var coerceAtLeast = kotlin_kotlin.$_$.wh;
  var to = kotlin_kotlin.$_$.ip;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var Companion_getInstance = kotlin_kotlin.$_$.d3;
  var DurationUnit_SECONDS_getInstance = kotlin_kotlin.$_$.t3;
  var toDuration = kotlin_kotlin.$_$.tm;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.l;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.j4;
  var contains = kotlin_kotlin.$_$.nj;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var startsWith = kotlin_kotlin.$_$.dl;
  var split = kotlin_kotlin.$_$.cl;
  var last = kotlin_kotlin.$_$.na;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var hashCode = kotlin_kotlin.$_$.bg;
  var equals = kotlin_kotlin.$_$.sf;
  var Duration__toString_impl_8d916b = kotlin_kotlin.$_$.o;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var Duration__hashCode_impl_u4exz6 = kotlin_kotlin.$_$.g;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var persistentHashMapOf = kotlin_org_jetbrains_kotlinx_kotlinx_collections_immutable.$_$.a;
  var persistentHashMapOf_0 = kotlin_org_jetbrains_kotlinx_kotlinx_collections_immutable.$_$.b;
  var AtomicReference = kotlin_kotlin.$_$.ed;
  var toMutableMap = kotlin_kotlin.$_$.rc;
  var KtMutableMap = kotlin_kotlin.$_$.k7;
  var IOException = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.g;
  var IOException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.b;
  var captureStack = kotlin_kotlin.$_$.gf;
  var get_request = kotlin_io_ktor_ktor_client_core.$_$.a1;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.h5;
  var Enum = kotlin_kotlin.$_$.en;
  var Severity_Debug_getInstance = kotlin_co_touchlab_kermit_core.$_$.f;
  var Severity_Info_getInstance = kotlin_co_touchlab_kermit_core.$_$.h;
  var Severity_Warn_getInstance = kotlin_co_touchlab_kermit_core.$_$.i;
  var Severity_Error_getInstance = kotlin_co_touchlab_kermit_core.$_$.g;
  var Severity_Assert_getInstance = kotlin_co_touchlab_kermit_core.$_$.e;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var platformLogWriter = kotlin_co_touchlab_kermit_core.$_$.d;
  var loggerConfigInit = kotlin_co_touchlab_kermit_core.$_$.b;
  var Logger = kotlin_co_touchlab_kermit.$_$.a;
  var Plugin_getInstance = kotlin_io_ktor_ktor_client_core.$_$.c;
  var get_ContentNegotiation = kotlin_io_ktor_ktor_client_content_negotiation.$_$.a;
  var get_HttpTimeout = kotlin_io_ktor_ktor_client_core.$_$.o;
  var json = kotlin_io_ktor_ktor_serialization_kotlinx_json.$_$.a;
  var _Duration___get_inWholeMilliseconds__impl__msfiry = kotlin_kotlin.$_$.i;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var HttpRequestBuilder = kotlin_io_ktor_ktor_client_core.$_$.q;
  var url = kotlin_io_ktor_ktor_client_core.$_$.w;
  var get_encodedPath = kotlin_io_ktor_ktor_http.$_$.s1;
  var HttpStatement = kotlin_io_ktor_ktor_client_core.$_$.z;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var CancellationException = kotlin_kotlin.$_$.fd;
  var HttpRequestTimeoutException = kotlin_io_ktor_ktor_client_core.$_$.n;
  var subtract = kotlin_kotlin.$_$.af;
  var DurationUnit_MILLISECONDS_getInstance = kotlin_kotlin.$_$.q3;
  var toDuration_0 = kotlin_kotlin.$_$.sm;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var HttpClient = kotlin_io_ktor_ktor_client_core.$_$.c1;
  var HttpClient_0 = kotlin_io_ktor_ktor_client_core.$_$.b1;
  var isSuccess = kotlin_io_ktor_ktor_http.$_$.w1;
  var KFunctionImpl = kotlin_kotlin.$_$.ni;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var HttpResponse = kotlin_io_ktor_ktor_client_core.$_$.y;
  var initMetadataForFunctionReference = kotlin_kotlin.$_$.fg;
  var URLBuilder_0 = kotlin_io_ktor_ktor_http.$_$.a1;
  var appendEncodedPathSegments = kotlin_io_ktor_ktor_http.$_$.g1;
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f3;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForObject(StringMasking, 'StringMasking');
  initMetadataForCompanion(Companion_0);
  initMetadataForInterface(SupabaseClient, 'SupabaseClient', VOID, VOID, VOID, [0]);
  initMetadataForClass(SupabaseClientImpl, 'SupabaseClientImpl', VOID, VOID, [SupabaseClient], [0]);
  initMetadataForClass(SupabaseClientBuilder, 'SupabaseClientBuilder');
  initMetadataForClass(SupabaseClientConfig, 'SupabaseClientConfig');
  initMetadataForClass(SupabaseNetworkConfig, 'SupabaseNetworkConfig');
  initMetadataForClass(AtomicMutableMap, 'AtomicMutableMap', VOID, VOID, [KtMutableMap]);
  initMetadataForClass(HttpRequestException, 'HttpRequestException', VOID, IOException);
  initMetadataForClass(RestException, 'RestException', VOID, Exception);
  initMetadataForClass(UnauthorizedRestException, 'UnauthorizedRestException', VOID, RestException);
  initMetadataForClass(BadRequestRestException, 'BadRequestRestException', VOID, RestException);
  initMetadataForClass(UnknownRestException, 'UnknownRestException', VOID, RestException);
  initMetadataForClass(NotFoundRestException, 'NotFoundRestException', VOID, RestException);
  initMetadataForClass(SupabaseEncodingException, 'SupabaseEncodingException', VOID, Exception);
  initMetadataForClass(LogLevel, 'LogLevel', VOID, Enum);
  initMetadataForClass(SupabaseLogger, 'SupabaseLogger');
  initMetadataForClass(KermitSupabaseLogger, 'KermitSupabaseLogger', VOID, SupabaseLogger);
  initMetadataForCoroutine($requestCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SupabaseHttpClient, 'SupabaseHttpClient', VOID, VOID, VOID, [0, 2]);
  initMetadataForClass(KtorSupabaseHttpClient, 'KtorSupabaseHttpClient', VOID, SupabaseHttpClient, VOID, [0, 2]);
  initMetadataForCoroutine($rawRequestCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SupabaseApi, 'SupabaseApi', VOID, SupabaseHttpClient, VOID, [0, 2, 1]);
  initMetadataForFunctionReference(MainPlugin$parseErrorResponse$ref, KFunctionImpl, VOID, [1]);
  function init() {
  }
  initMetadataForInterface(SupabasePlugin, 'SupabasePlugin', VOID, VOID, VOID, [0]);
  function resolveUrl(path) {
    var isBase = this.ebw().wvn_1 == null;
    var tmp0_elvis_lhs = this.ebw().wvn_1;
    // Inline function 'io.github.jan.supabase.buildUrl' call
    var baseUrl = tmp0_elvis_lhs == null ? this.yvn().qvj() : tmp0_elvis_lhs;
    var builder = URLBuilder_0(baseUrl);
    if (isBase) {
      appendEncodedPathSegments(builder, [this.uvn(), 'v' + this.tvn()]);
    }
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(path)) {
      appendEncodedPathSegments(builder, [path]);
    }
    return builder.ft7();
  }
  initMetadataForInterface(MainPlugin, 'MainPlugin', VOID, VOID, [SupabasePlugin], [1, 0]);
  initMetadataForClass(MainConfig, 'MainConfig', MainConfig);
  initMetadataForClass(PluginManager, 'PluginManager', VOID, VOID, VOID, [0]);
  function setup(builder, config) {
  }
  initMetadataForInterface(SupabasePluginProvider, 'SupabasePluginProvider');
  initMetadataForClass(KotlinXSerializer, 'KotlinXSerializer', KotlinXSerializer);
  //endregion
  function OSInformation$Companion$CURRENT$delegate$lambda() {
    var tmp;
    try {
      tmp = getOSInformation();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var e = $p;
        // Inline function 'io.github.jan.supabase.logging.e' call
        var tmp0 = Companion_getInstance_1().evj_1;
        // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
        var level = LogLevel_ERROR_getInstance();
        var tmp0_elvis_lhs = tmp0.fsu();
        if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_1().dvj_1 : tmp0_elvis_lhs) >= 0) {
          var tmp$ret$2 = 'Failed to get OS information, please report this issue';
          tmp0.fvj(level, e, tmp$ret$2);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function OSInformation$Companion$_get_CURRENT_$ref_anazu5() {
    return constructCallableReference(function (p0) {
      return p0.hvj();
    }, 1, 0, 515);
  }
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    tmp.gvj_1 = lazy(OSInformation$Companion$CURRENT$delegate$lambda);
  }
  protoOf(Companion).hvj = function () {
    var tmp0 = this.gvj_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('CURRENT', 1, tmp, OSInformation$Companion$_get_CURRENT_$ref_anazu5(), null);
    return tmp0.u1();
  };
  var Companion_instance;
  function Companion_getInstance_0() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function StringMasking() {
    StringMasking_instance = this;
    this.ivj_1 = listOf(['apikey', 'Authorization']);
  }
  protoOf(StringMasking).jvj = function (value, visibleCharacters, showLength) {
    if (isBlank(value))
      return value;
    return take(value, visibleCharacters) + '...' + (showLength ? ' (len=' + value.length + ')' : '');
  };
  protoOf(StringMasking).kvj = function (value, visibleCharacters, showLength, $super) {
    visibleCharacters = visibleCharacters === VOID ? 2 : visibleCharacters;
    showLength = showLength === VOID ? false : showLength;
    return $super === VOID ? this.jvj(value, visibleCharacters, showLength) : $super.jvj.call(this, value, visibleCharacters, showLength);
  };
  protoOf(StringMasking).lvj = function (value, visibleCharacters) {
    // Inline function 'io.github.jan.supabase.buildUrl' call
    var builder = URLBuilder(value);
    builder.ht5_1 = take(builder.ht5_1, visibleCharacters) + '...';
    return builder.ft7();
  };
  protoOf(StringMasking).mvj = function (value, visibleCharacters, $super) {
    visibleCharacters = visibleCharacters === VOID ? 2 : visibleCharacters;
    return $super === VOID ? this.lvj(value, visibleCharacters) : $super.lvj.call(this, value, visibleCharacters);
  };
  protoOf(StringMasking).nvj = function (headers) {
    // Inline function 'kotlin.collections.mapValues' call
    var this_0 = toMap(headers);
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination = LinkedHashMap_init_$Create$(mapCapacity(this_0.n1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s = this_0.s1().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp = element.t1();
      // Inline function 'kotlin.collections.component1' call
      var key = element.t1();
      // Inline function 'kotlin.collections.component2' call
      var value = element.u1();
      var tmp_0;
      if (StringMasking_getInstance().ivj_1.m1(key)) {
        var tmp0_safe_receiver = firstOrNull(value);
        var tmp_1;
        if (tmp0_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_1 = listOf_0(key === 'Authorization' ? 'Bearer ' + StringMasking_getInstance().kvj(drop(tmp0_safe_receiver, 7), VOID, true) : StringMasking_getInstance().kvj(tmp0_safe_receiver, VOID, true));
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = value;
      }
      var tmp$ret$4 = tmp_0;
      destination.z2(tmp, tmp$ret$4);
    }
    return toString(destination);
  };
  var StringMasking_instance;
  function StringMasking_getInstance() {
    if (StringMasking_instance == null)
      new StringMasking();
    return StringMasking_instance;
  }
  function Companion_0() {
    Companion_instance_0 = this;
    this.dvj_1 = LogLevel_INFO_getInstance();
    this.evj_1 = this.ovj('Supabase-Core');
  }
  protoOf(Companion_0).pvj = function (tag, level) {
    return new KermitSupabaseLogger(null, tag);
  };
  protoOf(Companion_0).ovj = function (tag, level, $super) {
    level = level === VOID ? null : level;
    return $super === VOID ? this.pvj(tag, level) : $super.pvj.call(this, tag, level);
  };
  var Companion_instance_0;
  function Companion_getInstance_1() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function SupabaseClient() {
  }
  function SupabaseClientImpl(config) {
    this.zvj_1 = config;
    this.avk_1 = this.zvj_1.pvk_1;
    this.bvk_1 = this.zvj_1.nvk_1;
    this.cvk_1 = this.zvj_1.jvk_1;
    this.dvk_1 = this.zvj_1.kvk_1;
    this.evk_1 = this.zvj_1.mvk_1.svk_1;
    this.fvk_1 = this.zvj_1.ovk_1;
    // Inline function 'io.github.jan.supabase.logging.i' call
    var tmp0 = Companion_getInstance_1().evj_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level = LogLevel_INFO_getInstance();
    var tmp0_elvis_lhs = tmp0.fsu();
    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_1().dvj_1 : tmp0_elvis_lhs) >= 0) {
      var tmp$ret$2 = 'SupabaseClient created! Please report any bugs you find.';
      tmp0.fvj(level, null, tmp$ret$2);
    }
    var tmp = this;
    var tmp_0;
    if (this.evk_1) {
      tmp_0 = 'https://' + this.cvk_1;
    } else {
      tmp_0 = 'http://' + this.cvk_1;
    }
    tmp.gvk_1 = tmp_0;
    this.hvk_1 = new KtorSupabaseHttpClient(this);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associate' call
    var this_0 = toList(this.zvj_1.qvk_1);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$(capacity);
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var key = element.zh();
      var value = element.ai();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(key, value(this));
      destination.z2(pair.xh_1, pair.yh_1);
    }
    tmp_1.ivk_1 = new PluginManager(destination);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = this.ivk_1.wvk_1.y2().t();
    while (_iterator__ex2g4s_0.u()) {
      var element_0 = _iterator__ex2g4s_0.v();
      element_0.odl();
    }
  }
  protoOf(SupabaseClientImpl).ebw = function () {
    return this.zvj_1;
  };
  protoOf(SupabaseClientImpl).xvj = function () {
    return this.avk_1;
  };
  protoOf(SupabaseClientImpl).wvj = function () {
    return this.bvk_1;
  };
  protoOf(SupabaseClientImpl).rvj = function () {
    return this.cvk_1;
  };
  protoOf(SupabaseClientImpl).svj = function () {
    return this.dvk_1;
  };
  protoOf(SupabaseClientImpl).vvj = function () {
    return this.evk_1;
  };
  protoOf(SupabaseClientImpl).yvj = function () {
    return this.fvk_1;
  };
  protoOf(SupabaseClientImpl).qvj = function () {
    return this.gvk_1;
  };
  protoOf(SupabaseClientImpl).uvj = function () {
    return this.hvk_1;
  };
  protoOf(SupabaseClientImpl).tvj = function () {
    return this.ivk_1;
  };
  function SupabaseClientBuilder$defaultSerializer$lambda($this$Json) {
    $this$Json.fmh_1 = true;
    return Unit_instance;
  }
  function SupabaseClientBuilder$install$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function SupabaseClientBuilder$install$lambda_0($plugin, $config) {
    return function (it) {
      return $plugin.xvk(it, $config);
    };
  }
  function SupabaseClientBuilder(supabaseUrl, supabaseKey) {
    this.yvk_1 = supabaseUrl;
    this.zvk_1 = supabaseKey;
    this.avl_1 = true;
    this.bvl_1 = null;
    this.cvl_1 = false;
    var tmp = this;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp.dvl_1 = toDuration(10, DurationUnit_SECONDS_getInstance());
    var tmp_0 = this;
    tmp_0.evl_1 = new KotlinXSerializer(Json(VOID, SupabaseClientBuilder$defaultSerializer$lambda));
    this.fvl_1 = get_defaultDispatcher();
    this.gvl_1 = null;
    this.hvl_1 = Companion_getInstance_0().hvj();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_1.ivl_1 = ArrayList_init_$Create$();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_2.jvl_1 = LinkedHashMap_init_$Create$_0();
    var module_0 = contains(this.yvk_1, 'realtime/v1') ? 'realtime/v1' : contains(this.yvk_1, 'auth/v1') ? 'auth/v1' : contains(this.yvk_1, 'storage/v1') ? 'storage/v1' : contains(this.yvk_1, 'rest/v1') ? 'rest/v1' : null;
    if (!this.cvl_1 && !(module_0 == null)) {
      // Inline function 'kotlin.error' call
      var message = 'The Supabase URL should not contain (' + module_0 + "), supabase-kt handles the url endpoints. If you want to use a custom url for a module, specify it within their builder but that's not necessary for normal Supabase projects";
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (startsWith(this.yvk_1, 'http://')) {
      this.avl_1 = false;
    }
  }
  protoOf(SupabaseClientBuilder).kvl = function () {
    return Companion_getInstance_1().dvj_1;
  };
  protoOf(SupabaseClientBuilder).lvl = function () {
    var config = new SupabaseClientConfig(last(split(this.yvk_1, ['//'])), this.zvk_1, this.kvl(), new SupabaseNetworkConfig(this.avl_1, this.bvl_1, this.ivl_1, this.dvl_1), this.evl_1, this.fvl_1, this.gvl_1, this.jvl_1, this.hvl_1);
    return new SupabaseClientImpl(config);
  };
  protoOf(SupabaseClientBuilder).mvl = function (block) {
    this.ivl_1.j1(block);
  };
  protoOf(SupabaseClientBuilder).nvl = function (plugin, init) {
    var config = plugin.ovl(init);
    plugin.pvl(this, config);
    var tmp0 = this.jvl_1;
    var tmp2 = plugin.t1();
    // Inline function 'kotlin.collections.set' call
    var value = SupabaseClientBuilder$install$lambda_0(plugin, config);
    tmp0.z2(tmp2, value);
  };
  protoOf(SupabaseClientBuilder).qvl = function (plugin, init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = SupabaseClientBuilder$install$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.nvl(plugin, init);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.nvl.call(this, plugin, init);
    }
    return tmp_0;
  };
  function SupabaseClientConfig(supabaseUrl, supabaseKey, defaultLogLevel, networkConfig, defaultSerializer, coroutineDispatcher, accessToken, plugins, osInformation) {
    this.jvk_1 = supabaseUrl;
    this.kvk_1 = supabaseKey;
    this.lvk_1 = defaultLogLevel;
    this.mvk_1 = networkConfig;
    this.nvk_1 = defaultSerializer;
    this.ovk_1 = coroutineDispatcher;
    this.pvk_1 = accessToken;
    this.qvk_1 = plugins;
    this.rvk_1 = osInformation;
  }
  protoOf(SupabaseClientConfig).toString = function () {
    return 'SupabaseClientConfig(supabaseUrl=' + this.jvk_1 + ', supabaseKey=' + this.kvk_1 + ', defaultLogLevel=' + this.lvk_1.toString() + ', networkConfig=' + this.mvk_1.toString() + ', defaultSerializer=' + toString(this.nvk_1) + ', coroutineDispatcher=' + this.ovk_1.toString() + ', accessToken=' + toString_0(this.pvk_1) + ', plugins=' + toString(this.qvk_1) + ', osInformation=' + toString_0(this.rvk_1) + ')';
  };
  protoOf(SupabaseClientConfig).hashCode = function () {
    var result = getStringHashCode(this.jvk_1);
    result = imul(result, 31) + getStringHashCode(this.kvk_1) | 0;
    result = imul(result, 31) + this.lvk_1.hashCode() | 0;
    result = imul(result, 31) + this.mvk_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.nvk_1) | 0;
    result = imul(result, 31) + hashCode(this.ovk_1) | 0;
    result = imul(result, 31) + (this.pvk_1 == null ? 0 : hashCode(this.pvk_1)) | 0;
    result = imul(result, 31) + hashCode(this.qvk_1) | 0;
    result = imul(result, 31) + (this.rvk_1 == null ? 0 : this.rvk_1.hashCode()) | 0;
    return result;
  };
  protoOf(SupabaseClientConfig).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SupabaseClientConfig))
      return false;
    if (!(this.jvk_1 === other.jvk_1))
      return false;
    if (!(this.kvk_1 === other.kvk_1))
      return false;
    if (!this.lvk_1.equals(other.lvk_1))
      return false;
    if (!this.mvk_1.equals(other.mvk_1))
      return false;
    if (!equals(this.nvk_1, other.nvk_1))
      return false;
    if (!equals(this.ovk_1, other.ovk_1))
      return false;
    if (!equals(this.pvk_1, other.pvk_1))
      return false;
    if (!equals(this.qvk_1, other.qvk_1))
      return false;
    if (!equals(this.rvk_1, other.rvk_1))
      return false;
    return true;
  };
  function SupabaseNetworkConfig(useHTTPS, httpEngine, httpConfigOverrides, requestTimeout) {
    this.svk_1 = useHTTPS;
    this.tvk_1 = httpEngine;
    this.uvk_1 = httpConfigOverrides;
    this.vvk_1 = requestTimeout;
  }
  protoOf(SupabaseNetworkConfig).toString = function () {
    return 'SupabaseNetworkConfig(useHTTPS=' + this.svk_1 + ', httpEngine=' + toString_0(this.tvk_1) + ', httpConfigOverrides=' + toString(this.uvk_1) + ', requestTimeout=' + Duration__toString_impl_8d916b(this.vvk_1) + ')';
  };
  protoOf(SupabaseNetworkConfig).hashCode = function () {
    var result = getBooleanHashCode(this.svk_1);
    result = imul(result, 31) + (this.tvk_1 == null ? 0 : hashCode(this.tvk_1)) | 0;
    result = imul(result, 31) + hashCode(this.uvk_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.vvk_1) | 0;
    return result;
  };
  protoOf(SupabaseNetworkConfig).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SupabaseNetworkConfig))
      return false;
    if (!(this.svk_1 === other.svk_1))
      return false;
    if (!equals(this.tvk_1, other.tvk_1))
      return false;
    if (!equals(this.uvk_1, other.uvk_1))
      return false;
    if (!equals(this.vvk_1, other.vvk_1))
      return false;
    return true;
  };
  function get_supabaseJson() {
    _init_properties_Utils_kt__jo07cx();
    return supabaseJson;
  }
  var supabaseJson;
  function putJsonObject(_this__u8e3s4, jsonObject) {
    _init_properties_Utils_kt__jo07cx();
    var _iterator__ex2g4s = jsonObject.x2().t();
    while (_iterator__ex2g4s.u()) {
      var key = _iterator__ex2g4s.v();
      _this__u8e3s4.gmj(key, ensureNotNull(jsonObject.je(key)));
    }
  }
  function supabaseJson$lambda($this$Json) {
    _init_properties_Utils_kt__jo07cx();
    $this$Json.fmh_1 = true;
    $this$Json.dmh_1 = false;
    return Unit_instance;
  }
  var properties_initialized_Utils_kt_xvi83j;
  function _init_properties_Utils_kt__jo07cx() {
    if (!properties_initialized_Utils_kt_xvi83j) {
      properties_initialized_Utils_kt_xvi83j = true;
      supabaseJson = Json(VOID, supabaseJson$lambda);
    }
  }
  function AtomicMutableMap$clear$lambda(it) {
    return it.r() ? it : persistentHashMapOf();
  }
  function AtomicMutableMap$putAll$lambda($from) {
    return function (it) {
      return it.svf($from);
    };
  }
  function AtomicMutableMap(pairs) {
    this.rvl_1 = new AtomicReference(persistentHashMapOf_0(pairs.slice()));
  }
  protoOf(AtomicMutableMap).s1 = function () {
    return toMutableMap(this.rvl_1.a9()).s1();
  };
  protoOf(AtomicMutableMap).x2 = function () {
    return toMutableMap(this.rvl_1.a9()).x2();
  };
  protoOf(AtomicMutableMap).y2 = function () {
    return toMutableMap(this.rvl_1.a9()).y2();
  };
  protoOf(AtomicMutableMap).n1 = function () {
    return this.rvl_1.a9().n1();
  };
  protoOf(AtomicMutableMap).r = function () {
    return this.rvl_1.a9().r();
  };
  protoOf(AtomicMutableMap).w2 = function (key) {
    return this.rvl_1.a9().w2(key);
  };
  protoOf(AtomicMutableMap).u2 = function (key) {
    return this.rvl_1.a9().u2(key);
  };
  protoOf(AtomicMutableMap).v2 = function (value) {
    return this.rvl_1.a9().v2(value);
  };
  protoOf(AtomicMutableMap).c3 = function () {
    updateIfChanged(this.rvl_1, AtomicMutableMap$clear$lambda);
  };
  protoOf(AtomicMutableMap).b3 = function (from) {
    if (from.r())
      return Unit_instance;
    updateIfChanged(this.rvl_1, AtomicMutableMap$putAll$lambda(from));
  };
  protoOf(AtomicMutableMap).z2 = function (key, value) {
    while (true) {
      var cur = this.rvl_1.a9();
      var prev = cur.w2(key);
      var next = cur.z2(key, value);
      if (next === cur)
        return prev;
      if (this.rvl_1.c9(cur, next))
        return prev;
    }
  };
  protoOf(AtomicMutableMap).a3 = function (key) {
    $l$loop: while (true) {
      var cur = this.rvl_1.a9();
      var tmp0_elvis_lhs = cur.w2(key);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.run' call
        var next = cur.a3(key);
        if (next === cur)
          return null;
        if (this.rvl_1.c9(cur, next))
          return null;
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var prev = tmp;
      var next_0 = cur.a3(key);
      if (this.rvl_1.c9(cur, next_0))
        return prev;
    }
  };
  function updateIfChanged(_this__u8e3s4, callback) {
    while (true) {
      var currentValue = _this__u8e3s4.a9();
      var newValue = callback(currentValue);
      if (currentValue === newValue)
        return false;
      if (_this__u8e3s4.c9(currentValue, newValue))
        return true;
    }
  }
  function HttpRequestException(message, request) {
    IOException_init_$Init$('HTTP request to ' + request.ytr_1.ft7() + ' (' + request.ztr_1.ot2_1 + ') failed with message: ' + message, this);
    captureStack(this, HttpRequestException);
  }
  function RestException(error, description, response) {
    var tmp;
    if (description == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = '\n' + description;
    }
    var tmp1_elvis_lhs = tmp;
    Exception_init_$Init$(error + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs) + ('\nURL: ' + StringMasking_getInstance().mvj(get_request(response).ott())) + ('\nHeaders: ' + StringMasking_getInstance().nvj(get_request(response).dt2())) + ('\nHttp Method: ' + get_request(response).ntt().ot2_1), this);
    captureStack(this, RestException);
    this.svl_1 = error;
    this.tvl_1 = description;
    this.uvl_1 = response;
    this.vvl_1 = this.uvl_1.zbq().yt2_1;
  }
  function UnauthorizedRestException(error, response, message) {
    message = message === VOID ? null : message;
    RestException.call(this, error, message, response);
    captureStack(this, UnauthorizedRestException);
  }
  function BadRequestRestException(error, response, message) {
    message = message === VOID ? null : message;
    RestException.call(this, error, message, response);
    captureStack(this, BadRequestRestException);
  }
  function UnknownRestException(error, response, message) {
    message = message === VOID ? null : message;
    RestException.call(this, error, message, response);
    captureStack(this, UnknownRestException);
  }
  function NotFoundRestException(error, response, message) {
    message = message === VOID ? null : message;
    RestException.call(this, error, message, response);
    captureStack(this, NotFoundRestException);
  }
  function SupabaseEncodingException(message) {
    Exception_init_$Init$(message, this);
    captureStack(this, SupabaseEncodingException);
  }
  var LogLevel_DEBUG_instance;
  var LogLevel_INFO_instance;
  var LogLevel_WARNING_instance;
  var LogLevel_ERROR_instance;
  var LogLevel_NONE_instance;
  var LogLevel_entriesInitialized;
  function LogLevel_initEntries() {
    if (LogLevel_entriesInitialized)
      return Unit_instance;
    LogLevel_entriesInitialized = true;
    LogLevel_DEBUG_instance = new LogLevel('DEBUG', 0);
    LogLevel_INFO_instance = new LogLevel('INFO', 1);
    LogLevel_WARNING_instance = new LogLevel('WARNING', 2);
    LogLevel_ERROR_instance = new LogLevel('ERROR', 3);
    LogLevel_NONE_instance = new LogLevel('NONE', 4);
  }
  function LogLevel(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function LogLevel_DEBUG_getInstance() {
    LogLevel_initEntries();
    return LogLevel_DEBUG_instance;
  }
  function LogLevel_INFO_getInstance() {
    LogLevel_initEntries();
    return LogLevel_INFO_instance;
  }
  function LogLevel_WARNING_getInstance() {
    LogLevel_initEntries();
    return LogLevel_WARNING_instance;
  }
  function LogLevel_ERROR_getInstance() {
    LogLevel_initEntries();
    return LogLevel_ERROR_instance;
  }
  function SupabaseLogger() {
  }
  function toSeverity($this, $receiver) {
    var tmp;
    switch ($receiver.a1_1) {
      case 0:
        tmp = Severity_Debug_getInstance();
        break;
      case 1:
        tmp = Severity_Info_getInstance();
        break;
      case 2:
        tmp = Severity_Warn_getInstance();
        break;
      case 3:
        tmp = Severity_Error_getInstance();
        break;
      case 4:
        tmp = Severity_Assert_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function getLevelOrDefault($this) {
    var tmp0_elvis_lhs = $this.wvl_1;
    return tmp0_elvis_lhs == null ? Companion_getInstance_1().dvj_1 : tmp0_elvis_lhs;
  }
  function KermitSupabaseLogger(initialLevel, tag) {
    SupabaseLogger.call(this);
    this.wvl_1 = initialLevel;
    this.xvl_1 = new Logger(loggerConfigInit([platformLogWriter()], Severity_Debug_getInstance()), tag);
  }
  protoOf(KermitSupabaseLogger).fsu = function () {
    return this.wvl_1;
  };
  protoOf(KermitSupabaseLogger).fvj = function (level, throwable, message) {
    if (level.i3(getLevelOrDefault(this)) >= 0) {
      this.xvl_1.bv9(toSeverity(this, level), this.xvl_1.c5o(), throwable, message);
    }
  };
  function defaultHeaders($this, $receiver) {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_0 = $this.zvl_1;
    if (!isBlank(this_0)) {
      $receiver.fsq('apikey', $this.zvl_1);
    }
    $receiver.fsq('X-Client-Info', 'supabase-kt/3.5.0');
    var tmp0_safe_receiver = $this.avm_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $receiver.fsq('X-Supabase-Client-Platform', tmp0_safe_receiver.gvm_1);
      var tmp0_safe_receiver_0 = tmp0_safe_receiver.hvm_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        $receiver.fsq('X-Supabase-Client-Platform-Version', tmp0_safe_receiver_0);
        tmp = Unit_instance;
      }
    }
  }
  function applyDefaultConfiguration($this, $receiver, modifiers) {
    var tmp = Plugin_getInstance();
    $receiver.ett(tmp, KtorSupabaseHttpClient$applyDefaultConfiguration$lambda($this));
    var tmp_0 = get_ContentNegotiation();
    $receiver.ett(tmp_0, KtorSupabaseHttpClient$applyDefaultConfiguration$lambda_0);
    var tmp_1 = get_HttpTimeout();
    $receiver.ett(tmp_1, KtorSupabaseHttpClient$applyDefaultConfiguration$lambda_1($this));
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = modifiers.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      element($receiver);
    }
  }
  function KtorSupabaseHttpClient$httpClient$lambda(this$0) {
    return function ($this$HttpClient) {
      applyDefaultConfiguration(this$0, $this$HttpClient, this$0.evm_1);
      return Unit_instance;
    };
  }
  function KtorSupabaseHttpClient$httpClient$lambda_0(this$0) {
    return function ($this$HttpClient) {
      applyDefaultConfiguration(this$0, $this$HttpClient, this$0.evm_1);
      return Unit_instance;
    };
  }
  function KtorSupabaseHttpClient$applyDefaultConfiguration$lambda$lambda(this$0) {
    return function ($this$headers) {
      defaultHeaders(this$0, $this$headers);
      return Unit_instance;
    };
  }
  function KtorSupabaseHttpClient$applyDefaultConfiguration$lambda(this$0) {
    return function ($this$install) {
      $this$install.qu1(KtorSupabaseHttpClient$applyDefaultConfiguration$lambda$lambda(this$0));
      $this$install.pt6(443);
      return Unit_instance;
    };
  }
  function KtorSupabaseHttpClient$applyDefaultConfiguration$lambda_0($this$install) {
    json($this$install, get_supabaseJson());
    return Unit_instance;
  }
  function KtorSupabaseHttpClient$applyDefaultConfiguration$lambda_1(this$0) {
    return function ($this$install) {
      $this$install.fui(_Duration___get_inWholeMilliseconds__impl__msfiry(this$0.cvm_1));
      return Unit_instance;
    };
  }
  function $requestCOROUTINE$(_this__u8e3s4, url, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qvm_1 = _this__u8e3s4;
    this.rvm_1 = url;
    this.svm_1 = builder;
  }
  protoOf($requestCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp_0 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.rvm_1);
            this.svm_1(this_0);
            tmp_0.uvm_1 = this_0;
            this.tvm_1 = get_encodedPath(this.uvm_1.ytr_1);
            var tmp0 = Companion_getInstance_1().evj_1;
            var level = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs = tmp0.fsu();
            if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_1().dvj_1 : tmp0_elvis_lhs) >= 0) {
              tmp0.fvj(level, null, 'Starting ' + this.uvm_1.ztr_1.ot2_1 + ' request to endpoint ' + this.tvm_1);
            }

            this.o9_1 = 2;
            var tmp0_0 = this.qvm_1.fvm_1;
            var tmp2 = this.rvm_1;
            var block = this.svm_1;
            var this_1 = new HttpRequestBuilder();
            url(this_1, tmp2);
            block(this_1);
            this.n9_1 = 1;
            suspendResult = (new HttpStatement(this_1, tmp0_0)).pv2(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.vvm_1 = suspendResult;
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof HttpRequestTimeoutException) {
              var e = this.q9_1;
              var tmp_2 = this;
              var tmp0_1 = Companion_getInstance_1().evj_1;
              var level_0 = LogLevel_DEBUG_getInstance();
              var tmp0_elvis_lhs_0 = tmp0_1.fsu();
              if (level_0.i3(tmp0_elvis_lhs_0 == null ? Companion_getInstance_1().dvj_1 : tmp0_elvis_lhs_0) >= 0) {
                tmp0_1.fvj(level_0, e, this.uvm_1.ztr_1.ot2_1 + ' request to endpoint ' + this.tvm_1 + ' timed out after ' + Duration__toString_impl_8d916b(this.qvm_1.cvm_1));
              }
              throw e;
            } else {
              var tmp_3 = this.q9_1;
              if (tmp_3 instanceof CancellationException) {
                var e_0 = this.q9_1;
                var tmp_4 = this;
                var tmp0_2 = Companion_getInstance_1().evj_1;
                var level_1 = LogLevel_DEBUG_getInstance();
                var tmp0_elvis_lhs_1 = tmp0_2.fsu();
                if (level_1.i3(tmp0_elvis_lhs_1 == null ? Companion_getInstance_1().dvj_1 : tmp0_elvis_lhs_1) >= 0) {
                  tmp0_2.fvj(level_1, e_0, this.uvm_1.ztr_1.ot2_1 + ' request to endpoint ' + this.tvm_1 + ' was cancelled');
                }
                throw e_0;
              } else {
                var tmp_5 = this.q9_1;
                if (tmp_5 instanceof Exception) {
                  var e_1 = this.q9_1;
                  var tmp_6 = this;
                  var tmp0_3 = Companion_getInstance_1().evj_1;
                  var level_2 = LogLevel_DEBUG_getInstance();
                  var tmp0_elvis_lhs_2 = tmp0_3.fsu();
                  if (level_2.i3(tmp0_elvis_lhs_2 == null ? Companion_getInstance_1().dvj_1 : tmp0_elvis_lhs_2) >= 0) {
                    tmp0_3.fvj(level_2, e_1, this.uvm_1.ztr_1.ot2_1 + ' request to endpoint ' + this.tvm_1 + ' failed with exception ' + e_1.message);
                  }
                  var tmp0_elvis_lhs_3 = e_1.message;
                  throw new HttpRequestException(tmp0_elvis_lhs_3 == null ? '' : tmp0_elvis_lhs_3, this.uvm_1);
                } else {
                  throw this.q9_1;
                }
              }
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            var response = this.vvm_1;
            Companion_getInstance();
            var this_2 = subtract(response.xtt().ksr_1, response.wtt().ksr_1);
            var responseTime = toDuration_0(this_2, DurationUnit_MILLISECONDS_getInstance());
            var tmp0_4 = Companion_getInstance_1().evj_1;
            var level_3 = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs_4 = tmp0_4.fsu();
            if (level_3.i3(tmp0_elvis_lhs_4 == null ? Companion_getInstance_1().dvj_1 : tmp0_elvis_lhs_4) >= 0) {
              tmp0_4.fvj(level_3, null, this.uvm_1.ztr_1.ot2_1 + ' request to endpoint ' + this.tvm_1 + ' successfully finished in ' + Duration__toString_impl_8d916b(responseTime));
            }

            return response;
        }
      } catch ($p) {
        var e_2 = $p;
        if (this.o9_1 === 3) {
          throw e_2;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_2;
        }
      }
     while (true);
  };
  function KtorSupabaseHttpClient(supabase) {
    SupabaseHttpClient.call(this);
    this.yvl_1 = supabase;
    this.zvl_1 = this.yvl_1.svj();
    this.avm_1 = this.yvl_1.ebw().rvk_1;
    this.bvm_1 = this.yvl_1.ebw().mvk_1;
    this.cvm_1 = this.bvm_1.vvk_1;
    this.dvm_1 = this.bvm_1.tvk_1;
    this.evm_1 = this.bvm_1.uvk_1;
    // Inline function 'io.github.jan.supabase.logging.d' call
    var tmp0 = Companion_getInstance_1().evj_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level = LogLevel_DEBUG_getInstance();
    var tmp0_elvis_lhs = tmp0.fsu();
    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_1().dvj_1 : tmp0_elvis_lhs) >= 0) {
      var tmp$ret$2 = 'Creating KtorSupabaseHttpClient with request timeout ' + Duration__toString_impl_8d916b(this.cvm_1) + ', HttpClientEngine: ' + toString_0(this.dvm_1);
      tmp0.fvj(level, null, tmp$ret$2);
    }
    var tmp = this;
    var tmp_0;
    if (!(this.dvm_1 == null)) {
      tmp_0 = HttpClient_0(this.dvm_1, KtorSupabaseHttpClient$httpClient$lambda(this));
    } else {
      tmp_0 = HttpClient(KtorSupabaseHttpClient$httpClient$lambda_0(this));
    }
    tmp.fvm_1 = tmp_0;
  }
  protoOf(KtorSupabaseHttpClient).wvm = function (url, builder, $completion) {
    var tmp = new $requestCOROUTINE$(this, url, builder, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function $rawRequestCOROUTINE$(_this__u8e3s4, url, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fvn_1 = _this__u8e3s4;
    this.gvn_1 = url;
    this.hvn_1 = builder;
  }
  protoOf($rawRequestCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = this.fvn_1.lvn_1.wvm(this.gvn_1, this.hvn_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ivn_1 = suspendResult;
            var it = this.ivn_1;
            if (!isSuccess(it.zbq()) && !(this.fvn_1.kvn_1 == null)) {
              this.n9_1 = 3;
              suspendResult = this.fvn_1.kvn_1(it, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            return this.ivn_1;
          case 3:
            throw suspendResult;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function SupabaseApi(resolveUrl, parseErrorResponse, httpClient) {
    parseErrorResponse = parseErrorResponse === VOID ? null : parseErrorResponse;
    SupabaseHttpClient.call(this);
    this.jvn_1 = resolveUrl;
    this.kvn_1 = parseErrorResponse;
    this.lvn_1 = httpClient;
  }
  protoOf(SupabaseApi).wvm = function (url, builder, $completion) {
    return this.mvn(this.jvn_1(url), builder, $completion);
  };
  protoOf(SupabaseApi).mvn = function (url, builder, $completion) {
    var tmp = new $rawRequestCOROUTINE$(this, url, builder, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function supabaseApi(_this__u8e3s4, plugin) {
    var tmp = MainPlugin$resolveUrl$ref(plugin);
    return supabaseApi_0(_this__u8e3s4, tmp, MainPlugin$parseErrorResponse$ref_0(plugin));
  }
  function supabaseApi_0(_this__u8e3s4, resolveUrl, parseErrorResponse) {
    parseErrorResponse = parseErrorResponse === VOID ? null : parseErrorResponse;
    return new SupabaseApi(resolveUrl, parseErrorResponse, _this__u8e3s4.uvj());
  }
  function MainPlugin$parseErrorResponse$ref(p0) {
    KFunctionImpl.call(this, 1, 2, 516);
    this.qvn_1 = p0;
  }
  protoOf(MainPlugin$parseErrorResponse$ref).rvn = function (p0, $completion) {
    return this.qvn_1.svn(p0, $completion);
  };
  protoOf(MainPlugin$parseErrorResponse$ref).ja = function (p1, $completion) {
    return this.rvn(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  function SupabaseHttpClient() {
  }
  function MainPlugin() {
  }
  function MainConfig() {
    this.wvn_1 = null;
    this.xvn_1 = null;
  }
  function MainPlugin$resolveUrl$ref(p0) {
    return constructCallableReference(function (p0_0) {
      return p0.vvn(p0_0);
    }, 1, 0, 517, 'resolveUrl', [p0]);
  }
  function MainPlugin$parseErrorResponse$ref_0(p0) {
    var i = new MainPlugin$parseErrorResponse$ref(p0);
    return constructCallableReference(function (p0, $completion) {
      return i.rvn(p0, $completion);
    }, 1, 1, 516, 'parseErrorResponse', [p0]);
  }
  function PluginManager(installedPlugins) {
    this.wvk_1 = installedPlugins;
    // Inline function 'io.github.jan.supabase.logging.d' call
    var tmp0 = Companion_getInstance_1().evj_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level = LogLevel_DEBUG_getInstance();
    var tmp0_elvis_lhs = tmp0.fsu();
    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_1().dvj_1 : tmp0_elvis_lhs) >= 0) {
      var tmp$ret$2 = 'PluginManager initialized with plugins: ' + toString(this.wvk_1.x2());
      tmp0.fvj(level, null, tmp$ret$2);
    }
  }
  function SupabasePlugin() {
  }
  function SupabasePluginProvider() {
  }
  function KotlinXSerializer(json) {
    json = json === VOID ? Default_getInstance() : json;
    this.zvn_1 = json;
  }
  protoOf(KotlinXSerializer).avo = function (type, value) {
    return this.zvn_1.b72(serializer(this.zvn_1.c75(), type), value);
  };
  protoOf(KotlinXSerializer).bvo = function (type, value) {
    return this.zvn_1.c72(serializer(this.zvn_1.c75(), type), value);
  };
  function get_defaultDispatcher() {
    _init_properties_DefaultDispatcher_kt__jv2x92();
    return defaultDispatcher;
  }
  var defaultDispatcher;
  var properties_initialized_DefaultDispatcher_kt_61k2vc;
  function _init_properties_DefaultDispatcher_kt__jv2x92() {
    if (!properties_initialized_DefaultDispatcher_kt_61k2vc) {
      properties_initialized_DefaultDispatcher_kt_61k2vc = true;
      defaultDispatcher = Dispatchers_getInstance().i1h_1;
    }
  }
  function getOSInformation() {
    return null;
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_getInstance_0;
  _.$_$.b = StringMasking_getInstance;
  _.$_$.c = Companion_getInstance_1;
  _.$_$.d = LogLevel_DEBUG_getInstance;
  _.$_$.e = LogLevel_ERROR_getInstance;
  _.$_$.f = LogLevel_INFO_getInstance;
  _.$_$.g = LogLevel_WARNING_getInstance;
  _.$_$.h = AtomicMutableMap;
  _.$_$.i = BadRequestRestException;
  _.$_$.j = NotFoundRestException;
  _.$_$.k = RestException;
  _.$_$.l = SupabaseEncodingException;
  _.$_$.m = UnauthorizedRestException;
  _.$_$.n = UnknownRestException;
  _.$_$.o = SupabaseApi;
  _.$_$.p = supabaseApi;
  _.$_$.q = MainConfig;
  _.$_$.r = resolveUrl;
  _.$_$.s = MainPlugin;
  _.$_$.t = init;
  _.$_$.u = setup;
  _.$_$.v = SupabasePluginProvider;
  _.$_$.w = KotlinXSerializer;
  _.$_$.x = SupabaseClientBuilder;
  _.$_$.y = SupabaseClient;
  _.$_$.z = putJsonObject;
  _.$_$.a1 = get_supabaseJson;
  //endregion
  return _;
}));

//# sourceMappingURL=supabase-kt-supabase-kt.js.map
